import { Component, OnDestroy, OnInit } from "@angular/core";
import { NbLayoutScrollService } from "@nebular/theme";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "ngx-one-column-layout",
  styleUrls: ["./one-column.layout.scss"],
  template: `
    <nb-layout windowMode>
      <nb-layout-header fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive>
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
        <button
          *ngIf="showScroll"
          nbButton
          outline
          status="primary"
          shape="round"
          class="button-scroll-top"
          (click)="scrollTop()"
        >
          <nb-icon icon="arrow-upward-outline"></nb-icon>
        </button>
      </nb-layout-column>

      <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  showScroll: boolean = false;

  constructor(private scrollService: NbLayoutScrollService) {}

  ngOnInit() {
    this.scrollService
      .onScroll()
      .pipe(takeUntil(this.destroy$))
      .subscribe((obj) => {
        // console.log("scrollService.onScroll:", obj);
        this.scrollService
          .getPosition()
          .pipe(takeUntil(this.destroy$))
          .subscribe((position) => {
            // console.log("scrollService.getPosition:", position);
            this.showScroll = position.y > 100 ? true : false;
          });
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  scrollTop() {
    this.scrollService.scrollTo(0, 0);
  }
}
